import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { clearVatSettlementDetailsData, getVatSettlemenDetails, getVatSettlementRates } from "../../../../store/actions/reports/vatSettlement";
import { demoCompanyCorrelations } from "../../correlations";
import { vatSettlementDetailsConversion } from "./conversions";
import "./style.css";
import moment from "moment";

const ReportVatSettlementSheetHeaderDetails = (props) => {

  const {setSelectedSearch, objDetails, paramsFromUrl} = props;
  const navigate = useNavigate();
  const auth = useSelector(state => state.auth);
  const main = useSelector(state => state.main);
  const additionalData = useSelector(state => state.reports.search.additionalData);

  const dispatch = useDispatch();

  const report = vatSettlementDetailsConversion(useSelector(state => state.reports.search.additionalData?.vatSettlementDetails),
    useSelector(state => state.reports.search));
  const keys = report?.summaryHeader;

  const goToPrecogDetail = (documentId) => {
    let url = `precog-detail/${documentId}?from=reports&${window.location.href.split("?")[1]}`;
    return navigate(url);
  };

  const vatSettlementDetails = vatSettlementDetailsConversion(
    additionalData?.vatSettlementDetails, {}, goToPrecogDetail
  );

  // get details if not present in store
  useEffect(() => {
    setSelectedSearch(true);
    if (!additionalData?.vatSettlementRates){
      dispatch(getVatSettlementRates(auth));
    }
    if (!vatSettlementDetails) {
      
      dispatch(getVatSettlemenDetails(
        demoCompanyCorrelations[main.companyUuidSelected].businessVat,
        paramsFromUrl.refYear,
        moment(paramsFromUrl.periodRef).locale("en").format("MMMM").toUpperCase(),
        objDetails.vatCode,
        objDetails.journalType
      ));
    }
    return () => {
      if (vatSettlementDetails) {
        dispatch(clearVatSettlementDetailsData());
      }
    };
  }, []);

  return (
    <div className="vatSettlement-header">
      <div className="vatSettlement-header-title">Riepilogo</div>
      <div className="vatSettlement-header-content">
        {keys?.map((key, index) => (
          <div className="vatSettlement-header-content-field" key={index}>
            <div className="vatSettlement-header-content-key">{key.label || key}</div>
            <div className="vatSettlement-header-content-value">
              {report?.summary[key.id || key] || "--"}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReportVatSettlementSheetHeaderDetails;
